module.exports=function(scope){ return `<!-- idScan match successful -->
{
    "data": {
        "glasses": false,
        "sessionTokenStatus": 0,
        "faceMapType": 0,
        "ageEstimateGroup": 4,
        "matchLevel": 5,
        "livenessStatus": 0,
        "idScanAgeEstimateGroup": 4,
        "auditTrailVerificationCheck": 1,
        "isLowQuality": false,
        "auditTrailMatchCheck": 1,
        "isReplayFaceMap": true
    },
    "meta": {
        "code": 200,
        "message": "The ZoOm 3D FaceMap evaluated and Liveness was proven.",
        "ok": true,
        "m": {
            "idCheckTimeInMS": ...,
            "prepareAndUpdateTimeInMS": ...,
            "totalDurationInMS": ...
        }
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/id-check.json.tpl